import { useContext, useEffect } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";
import { confirmDiscardUnsaved } from "./confirmDiscardUnsaved";

export function useUnsavedChangesGuard(when: boolean) {
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!when) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when]);

  useEffect(() => {
    if (!when) return;
    const nav = navigator as any;
    const originalPush = nav.push.bind(nav);
    const originalReplace = nav.replace.bind(nav);
    let prompting = false;

    const guard = (proceed: (...args: any[]) => void) => (...args: any[]) => {
      if (prompting) return;
      prompting = true;
      confirmDiscardUnsaved(
        () => {
          nav.push = originalPush;
          nav.replace = originalReplace;
          proceed(...args);
        },
        () => {
          prompting = false;
        }
      );
    };

    nav.push = guard(originalPush);
    nav.replace = guard(originalReplace);

    return () => {
      nav.push = originalPush;
      nav.replace = originalReplace;
    };
  }, [when, navigator]);
}
